import React, { useEffect, useState } from "react";
import configVars from "../../config";

const HviMessages = (props) => {

	const [message, setMessage] = useState('');
	const [loading, setLoading] = useState(false);

	useEffect(() => {

		let lang = 'sv';
		let type = 'hvi';

		if ( props.lang ) {
			lang = props.lang;
		}

		if ( props.type ) {
			type = props.type;
		}

		(async () => {

			setLoading(true);
			
			const response = await fetch(
				`${configVars.apiUrl}sustainchange/v1/gethvimsgs/?lang=${lang}&type=${type}&count=${props.count}`,
				{
					method: "GET",
					headers: {
						Authorization: `Basic ${configVars.auth}`,
					},
				}
			);
			
			const hviResponse = await response.json();

			if ( hviResponse ) {

				if ( hviResponse.message && hviResponse.message.length > 0 ) {
					setMessage( hviResponse.message );
				}

			}

			setLoading(false);

		})()

	}, [props.lang, props.type, props.count]);

	return (
		<div className="hvi-response-wrapper">

			{loading &&
				<div className="spinner-border" role="status" >
					<span className="visually-hidden">Loading...</span>
				</div>
			}

			<div dangerouslySetInnerHTML={{__html: message}}></div>
		</div>
	);
};

export default HviMessages;
